var _circle, _circle2, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D4F4C6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#2E2E2E",
    strokeOpacity: 0.05
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0208,
    cy: 40,
    rx: 30.0208,
    ry: 30,
    fill: "#37B400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5417 40C69.5417 56.2921 56.3251 69.5 40.0208 69.5C23.7166 69.5 10.5 56.2921 10.5 40C10.5 23.7079 23.7166 10.5 40.0208 10.5C56.3251 10.5 69.5417 23.7079 69.5417 40Z",
    stroke: "#2E2E2E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9545 46.0568L29.9886 40.0909L28 42.0795L35.9545 50.0341L53 32.9886L51.0114 31L35.9545 46.0568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.2d954a4880ccaba6186a43e90e17f32c.svg";
export { ForwardRef as ReactComponent };